'use client';

import { useEffect } from 'react';

export default function NotFound() {
  useEffect(() => {
    window.location.replace('/');
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center" style={{ background: '#0F2340', color: '#FFFFFF' }}>
      <p className="font-body text-sm">Redirecting to homepage...</p>
    </main>
  );
}
